import { SkinProblemFrequency } from "./v1";

export type SkinProblemFrequencyV1Type = keyof typeof SkinProblemFrequency;

export type SkinProblemFrequencyType = SkinProblemFrequencyV1Type;
